export { default } from './MyWallet'